var _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactUsIconRectenggle6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_153753",
    "data-name": "\\uC0AC\\uAC01\\uD615 153753",
    width: 24,
    height: 24,
    transform: "translate(24) rotate(90)",
    fill: "#1876d2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUsIconRectenggle6);
export default __webpack_public_path__ + "static/media/contact_us_icon_rectenggle6.a6379170a2991991c2a87d7f32eb1f9c.svg";
export { ForwardRef as ReactComponent };